export class promoteLargerPackaging {
  static init() {
    this.applyPackage();
    this.applyAllPackages();
    this.revertPackage();
    this.navigation();
  }

  private static action(href: string, action_type: string, action_id: string, item_id: number, applyList: {
    action_id: string, item_id: number
  }[]) {
    let body = JSON.stringify({
      "action": action_type,
      "action_id": action_id,
      "item_id": item_id,
    });

    if (action_type === "apply-all") {
      body = JSON.stringify({
        "action": action_type,
        "apply_list": applyList,
      });
    }

    fetch(href, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body,
    })
      .then(function (response) {
        if (response.status !== 200) {
          console.error(response.statusText, response.status)
        }

        if (response.status === 200) {
          location.reload();
        }
      })
      .catch(function (err) {
        console.error("Something went wrong!", err);
      });
  }

  private static actionLoop(elements: NodeListOf<HTMLAnchorElement>, action_type: string) {
    [].forEach.call(elements, (element: {
      addEventListener: (type: string, listener: (event: any) => void) => void; href: string; dataset: {
        actionId: string,
        itemId: string;
      };
    }) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();

        const href = element.href;
        const action_id = element.dataset.actionId;
        const item_id = parseInt(element.dataset.itemId);

        this.action(href, action_type, action_id, item_id, [])
      })
    });
  }

  static navigateAction(event: Event, element: HTMLElement, itemsCount: number) {
    event.preventDefault();
    const scrollBehavior: { [key: string]: string; } = {
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    }

    if (element.dataset.js && element.dataset.js === "promote-previous") {
      const previous: number = parseInt(element.dataset.previous)
      const current: number = parseInt(element.dataset.current)
      const min: number = parseInt(element.dataset.min)
      const previousIdentifier = (current === min) ? itemsCount : previous;
      const previous_item = document.querySelector(`[data-nav-item="${previousIdentifier}"]`);
      const next_arrow: HTMLElement = document.querySelector('[data-js="promote-next"]')

      element.dataset.current = previousIdentifier.toString()
      element.dataset.previous = (previousIdentifier - 1).toString()

      next_arrow.dataset.current = previousIdentifier.toString()
      next_arrow.dataset.next = (previousIdentifier + 1).toString()

      previous_item.scrollIntoView(scrollBehavior);
    }

    if (element.dataset.js && element.dataset.js === "promote-next") {
      const next: number = parseInt(element.dataset.next)
      const current: number = parseInt(element.dataset.current)
      const max: number = parseInt(element.dataset.max)
      const nextIdentifier = (current === max) ? 1 : next;
      const next_item: HTMLElement = document.querySelector(`[data-nav-item="${nextIdentifier}"]`);
      const previous_arrow: HTMLElement = document.querySelector('[data-js="promote-previous"]')

      element.dataset.current = nextIdentifier.toString()
      element.dataset.next = (nextIdentifier + 1).toString()

      previous_arrow.dataset.current = nextIdentifier.toString()
      previous_arrow.dataset.previous = (nextIdentifier - 1).toString()

      next_item.scrollIntoView(scrollBehavior);
    }
  }

  private static applyPackage() {
    const promoteLargerPackagingApplies: NodeListOf<HTMLAnchorElement>
      = document.querySelectorAll('[data-js="promote-larger-packaging_apply"]');
    this.actionLoop(promoteLargerPackagingApplies, "apply")
  }

  private static applyAllPackages() {
    const promoteLargerPackagingApplyAll: HTMLAnchorElement
      = document.querySelector('[data-js="promote-larger-packaging_apply-all"]');
    const promoteLargerPackagingApplies: NodeListOf<HTMLAnchorElement>
      = document.querySelectorAll('[data-js="promote-larger-packaging_apply"]');

    if (promoteLargerPackagingApplyAll) {
      promoteLargerPackagingApplyAll.addEventListener("click", (event) => {
        event.preventDefault();

        const applyList: { action_id: string, item_id: number }[] = [];
        [].forEach.call(promoteLargerPackagingApplies, (apply: {
          dataset: { actionId: string; itemId: string; }
        }) => {
          applyList.push({
            action_id: apply.dataset.actionId,
            item_id: parseInt(apply.dataset.itemId),
          });
        });

        this.action(promoteLargerPackagingApplyAll.href, "apply-all", null, null, applyList)
      });
    }
  }

  private static revertPackage() {
    const promoteLargerPackagingReverts: NodeListOf<HTMLAnchorElement>
      = document.querySelectorAll('[data-js="promote-larger-packaging_revert"]');
    this.actionLoop(promoteLargerPackagingReverts, "revert")
  }

  private static navigation() {
    const items: NodeList = document.querySelectorAll('[data-js="plp_notification-item"]');
    const previousButton: HTMLElement = document.querySelector('[data-js="promote-previous"]');
    const nextButton: HTMLElement = document.querySelector('[data-js="promote-next"]');

    [].forEach.call(items, (item: HTMLElement, index: number) => {
      item.dataset.navItem = (index + 1).toString()
    })

    if (previousButton) {
      previousButton.addEventListener("click", (event) => this.navigateAction(event, previousButton, items.length));
    }

    if (nextButton) {
      nextButton.addEventListener("click", (event) => this.navigateAction(event, nextButton, items.length));
    }
  }
}
